// extracted by mini-css-extract-plugin
export default {"containerLogo":"logo_containerLogo__447L-","logo":"logo_logo__thiFP","left":"logo_left__gCgku","right":"logo_right__ZYR+C","mid":"logo_mid__E2ejd"};